// util/websocket.js
export function buildWsUrl(path) {
    const { protocol, hostname, port } = window.location;
    const wsScheme = protocol === 'https:' ? 'wss' : 'ws';

    // 개발 환경: REACT_APP_WS_PORT가 있으면 사용, 없으면 기존 포트
    const devPort =
        process.env.NODE_ENV === 'development'
            ? process.env.REACT_APP_WS_PORT || '8000'
            : port;

    const hostPart =
        process.env.NODE_ENV === 'development'
            ? `${hostname}:${devPort}`
            : window.location.host;          // 운영은 443/80 그대로

    return `${wsScheme}://${hostPart}${path}`;
}
